// accessMatrix.js

import { SubscriptionPlan } from '../helpers/enums';
import * as PagePaths from './pagePath';
import { ROUTE_PATTERNS } from '../routes/linkableRoutes';
export const ACCESS_MATRIX = [
  {
    subscription: SubscriptionPlan.Executive,
    isAdmin: true,
    isOrgManager: false,
    Organization: true,
    permissions: {
      PersonalDashboard: true,
      OrganizationAdminDashboard: true,
      OrganizationMemberDashboard: false,
      VPX: true,
      LandingPage: true,
      Clients: true,
      ValuePropositions: true,
      InviteUsers: true,
      CreateOrganization: false,
      Profile: true,
      Fundamentals: true,
      BulkOperations: true,
    },
    Organization_Dashboard: {
      LicensesDetails: true,
      OrganizationEdit: true,
    },
    Organization_User: {
      Invite: true,
      Actions: true,
    },
  },
  {
    subscription: SubscriptionPlan.Executive,
    isAdmin: false,
    isOrgManager: true,
    Organization: true,
    permissions: {
      PersonalDashboard: true,
      OrganizationAdminDashboard: true,
      OrganizationMemberDashboard: false,
      VPX: true,
      LandingPage: true,
      Clients: true,
      ValuePropositions: true,
      InviteUsers: true,
      CreateOrganization: false,
      Profile: true,
      Fundamentals: true,
      BulkOperations: true,
    },
    Organization_Dashboard: {
      LicensesDetails: true,
      OrganizationEdit: true,
    },
    Organization_User: {
      Invite: true,
      Actions: true,
    },
  },
  {
    subscription: SubscriptionPlan.Premium,
    isAdmin: true,
    isOrgManager: false,
    Organization: true,
    permissions: {
      PersonalDashboard: true,
      OrganizationAdminDashboard: true,
      OrganizationMemberDashboard: false,
      VPX: true,
      LandingPage: true,
      Clients: true,
      ValuePropositions: true,
      InviteUsers: true,
      CreateOrganization: false,
      Profile: true,
      Fundamentals: true,
      BulkOperations: true,
    },
    Organization_Dashboard: {
      LicensesDetails: true,
      OrganizationEdit: true,
    },
    Organization_User: {
      Invite: true,
      Actions: true,
    },
  },
  {
    subscription: SubscriptionPlan.Premium,
    isAdmin: false,
    isOrgManager: true,
    Organization: true,
    permissions: {
      PersonalDashboard: true,
      OrganizationAdminDashboard: true,
      OrganizationMemberDashboard: false,
      VPX: true,
      LandingPage: true,
      Clients: true,
      ValuePropositions: true,
      InviteUsers: true,
      CreateOrganization: false,
      Profile: true,
      Fundamentals: true,
      BulkOperations: true,
    },
    Organization_Dashboard: {
      LicensesDetails: true,
      OrganizationEdit: true,
    },
    Organization_User: {
      Invite: true,
      Actions: true,
    },
  },
  {
    subscription: SubscriptionPlan.Executive,
    isAdmin: false,
    isOrgManager: false,
    Organization: true,
    permissions: {
      PersonalDashboard: true,
      OrganizationAdminDashboard: false,
      OrganizationMemberDashboard: true,
      VPX: true,
      LandingPage: true,
      Clients: true,
      ValuePropositions: true,
      InviteUsers: false,
      CreateOrganization: false,
      Profile: true,
      Fundamentals: true,
      BulkOperations: false,
    },
    Organization_Dashboard: {
      LicensesDetails: false,
      OrganizationEdit: false,
    },
    Organization_User: {
      Invite: true,
      Actions: true,
    },
  },
  {
    subscription: SubscriptionPlan.Executive,
    isAdmin: false,
    isOrgManager: false,
    Organization: false,
    permissions: {
      PersonalDashboard: true,
      OrganizationAdminDashboard: false,
      OrganizationMemberDashboard: false,
      VPX: true,
      LandingPage: true,
      Clients: true,
      ValuePropositions: true,
      InviteUsers: false,
      CreateOrganization: true,
      Profile: true,
      Fundamentals: true,
      BulkOperations: false,
    },
    Organization_Dashboard: {
      LicensesDetails: false,
      OrganizationEdit: false,
    },
    Organization_User: {
      Invite: false,
      Actions: false,
    },
  },
  {
    subscription: SubscriptionPlan.Premium,
    isAdmin: false,
    isOrgManager: false,
    Organization: false,
    permissions: {
      PersonalDashboard: true,
      OrganizationAdminDashboard: false,
      OrganizationMemberDashboard: false,
      VPX: true,
      LandingPage: true,
      Clients: true,
      ValuePropositions: true,
      InviteUsers: false,
      CreateOrganization: false,
      Profile: true,
      Fundamentals: true,
      BulkOperations: false,
    },
    Organization_Dashboard: {
      LicensesDetails: false,
      OrganizationEdit: false,
    },
    Organization_User: {
      Invite: false,
      Actions: false,
    },
  },
  {
    subscription: SubscriptionPlan.Premium,
    isAdmin: false,
    isOrgManager: false,
    Organization: true,
    permissions: {
      PersonalDashboard: true,
      OrganizationAdminDashboard: false,
      OrganizationMemberDashboard: true,
      VPX: true,
      LandingPage: true,
      Clients: true,
      ValuePropositions: true,
      InviteUsers: false,
      CreateOrganization: false,
      Profile: true,
      Fundamentals: true,
      BulkOperations: false,
    },
    Organization_Dashboard: {
      LicensesDetails: false,
      OrganizationEdit: false,
    },
    Organization_User: {
      Invite: false,
      Actions: false,
    },
  },
  {
    subscription: SubscriptionPlan.Free,
    isAdmin: false,
    isOrgManager: false,
    Organization: false,
    permissions: {
      PersonalDashboard: true,
      OrganizationAdminDashboard: false,
      OrganizationMemberDashboard: false,
      VPX: true,
      LandingPage: true,
      Clients: true,
      ValuePropositions: true,
      InviteUsers: false,
      CreateOrganization: false,
      Profile: true,
      Fundamentals: true,
      BulkOperations: false,
    },
    Organization_Dashboard: {
      LicensesDetails: false,
      OrganizationEdit: false,
    },
    Organization_User: {
      Invite: false,
      Actions: false,
    },
  },
  {
    subscription: SubscriptionPlan.New,
    isAdmin: false,
    isOrgManager: false,
    Organization: true,
    permissions: {
      PersonalDashboard: true,
      OrganizationAdminDashboard: false,
      OrganizationMemberDashboard: false,
      VPX: true,
      LandingPage: false,
      Clients: false,
      ValuePropositions: false,
      InviteUsers: false,
      Profile: true,
      Fundamentals: false,
      BulkOperations: false,
    },
    Organization_Dashboard: {
      LicensesDetails: false,
      OrganizationEdit: false,
    },
    Organization_User: {
      Invite: false,
      Actions: false,
    },
  },
  {
    subscription: SubscriptionPlan.New,
    isAdmin: false,
    isOrgManager: false,
    Organization: false,
    permissions: {
      PersonalDashboard: true,
      OrganizationAdminDashboard: false,
      OrganizationMemberDashboard: false,
      VPX: true,
      LandingPage: true,
      Clients: true,
      ValuePropositions: true,
      InviteUsers: false,
      CreateOrganization: false,
      Profile: true,
      Fundamentals: true,
      BulkOperations: false,
    },
    Organization_Dashboard: {
      LicensesDetails: false,
      OrganizationEdit: false,
    },
    Organization_User: {
      Invite: false,
      Actions: false,
    },
  },
  {
    subscription: SubscriptionPlan.Free,
    isAdmin: false,
    isOrgManager: false,
    Organization: true,
    permissions: {
      PersonalDashboard: true,
      OrganizationAdminDashboard: false,
      OrganizationMemberDashboard: false, // Free users should NOT have access to organization features
      VPX: true,
      LandingPage: false,
      Clients: false,
      ValuePropositions: false,
      InviteUsers: false,
      Profile: true,
      Fundamentals: false,
      BulkOperations: false,
    },
    Organization_Dashboard: {
      LicensesDetails: false,
      OrganizationEdit: false,
    },
    Organization_User: {
      Invite: false,
      Actions: false,
    },
  },
  {
    subscription: SubscriptionPlan.Free,
    isAdmin: false,
    isOrgManager: true,
    Organization: true,
    permissions: {
      PersonalDashboard: true,
      OrganizationAdminDashboard: false,
      OrganizationMemberDashboard: false, // Free users should NOT have access to organization features
      VPX: true,
      LandingPage: false,
      Clients: false,
      ValuePropositions: false,
      InviteUsers: false,
      Profile: true,
      Fundamentals: false,
      BulkOperations: false,
    },
    Organization_Dashboard: {
      LicensesDetails: false, // Free tier org managers cannot see license details
      OrganizationEdit: false,
    },
    Organization_User: {
      Invite: false,
      Actions: false,
    },
  },
  {
    subscription: SubscriptionPlan.Free,
    isAdmin: false,
    isOrgManager: false,
    Organization: false,
    permissions: {
      PersonalDashboard: true,
      OrganizationAdminDashboard: false,
      OrganizationMemberDashboard: false,
      VPX: true,
      LandingPage: false,
      Clients: false,
      ValuePropositions: false,
      InviteUsers: false,
      CreateOrganization: false, // Free users cannot create organizations
      Profile: true,
      Fundamentals: false,
      BulkOperations: false,
    },
    Organization_Dashboard: {
      LicensesDetails: false,
      OrganizationEdit: false,
    },
    Organization_User: {
      Invite: false,
      Actions: false,
    },
  },
];

export const RouteGroups = [
  // === Personal Dashboard ===
  {
    paths: [PagePaths?.DASHBOARDS_PATH],
    feature: 'PersonalDashboard',
  },

  // === Organization ADMIN Dashboard ===
  {
    paths: [
      PagePaths.ORGANIZATION_ORGANIZATION_PATH,
      PagePaths.ORGANIZATION_DASHBOARD_PATH,
      PagePaths.ORGANIZATION_LICENSE_CHANGE_CONFIRM_PATH,
      PagePaths.ORGANIZATION_CLIENTS_PATH,
      PagePaths.ORGANIZATION_USERS_PATH,
      PagePaths.ORGANIZATION_VALUE_PROPOSITIONS_PATH,
      PagePaths.ORGANIZATION_EDIT_ORGANIZATION_DETAILS_PATH,
    ],
    feature: 'OrganizationAdminDashboard',
  },

  // === Organization Member (Non Admin) Dashboard ===
  {
    paths: [
      PagePaths.ORGANIZATION_ORGANIZATION_PATH,
      PagePaths.ORGANIZATION_DASHBOARD_PATH,
      PagePaths.ORGANIZATION_LICENSE_CHANGE_CONFIRM_PATH,
      PagePaths.ORGANIZATION_CLIENTS_PATH,
      PagePaths.ORGANIZATION_VALUE_PROPOSITIONS_PATH,
      PagePaths.ORGANIZATION_USERS_PATH,
      PagePaths.ORGANIZATION_EDIT_ORGANIZATION_DETAILS_PATH,
    ],
    feature: 'OrganizationMemberDashboard',
  },

  // === VPX ===
  {
    paths: [
      PagePaths.VPX_LIST_PATH,
      PagePaths.VPX_USER_PROFILE_PATH,
      ROUTE_PATTERNS.USER_PROFILE,
      PagePaths.VPX_ORGANIZATION_PROFILE_PATH,
      PagePaths.VPX_INVITATION_LIST_PATH,
      PagePaths.VPX_INVITATION_PUBLIC_PATH,
      PagePaths.VPX_INVITATION_PRIVATE_PATH,
    ],
    feature: 'VPX',
  },

  // === Landing Page ===
  {
    paths: [PagePaths.HOME_PATH, PagePaths.LANDING_PAGE_PATH],
    feature: 'LandingPage',
  },

  // === Clients ===
  {
    paths: [
      PagePaths.CLIENT_LIST_PATH,
      PagePaths.ADD_CLIENT_PATH,
      PagePaths.EDIT_CLIENT_PATH,
      PagePaths.ORGANIZATION_ADD_ORGANIZATION_CLIENT_PATH,
      PagePaths.ORGANIZATION_EDIT_ORGANIZATION_CLIENT_PATH,
    ],
    feature: 'Clients',
  },

  // === Value Propositions ===
  {
    paths: [
      PagePaths.VALUE_PROPOSITIONS_LIST_PATH,
      PagePaths.ADD_VALUE_PROPOSITION_PATH,
      PagePaths.EDIT_VALUE_PROPOSITION_PATH,
      ROUTE_PATTERNS.EDIT_VP,
      PagePaths.SHARED_VALUE_PROPOSITION_PATH,
    ],
    feature: 'ValuePropositions',
  },

  // === Profile ===
  {
    paths: [
      PagePaths.PROFILE_PATH,
      PagePaths.PROFILE_PERSONAL_INFORMATION_PATH,
      PagePaths.PROFILE_SECURITY_PATH,
      PagePaths.PROFILE_SUBSCRIPTION_PATH,
    ],
    feature: 'Profile',
  },

  // === Invite Users ===
  {
    paths: [PagePaths.ADMIN_INVITE_NEW_USERS],
    feature: 'InviteUsers',
  },

  // === Create Organization ===
  {
    paths: [PagePaths.ORGANIZATION_CREATE_ORGANIZATION, PagePaths.ORGANIZATION_REACTIVATE_PATH],
    feature: 'CreateOrganization',
  },

  // === Fundamentals ===
  {
    paths: [
      ROUTE_PATTERNS.FUNDAMENTALS,
      ROUTE_PATTERNS.ADD_FUNDAMENTAL,
      ROUTE_PATTERNS.EDIT_FUNDAMENTAL,
      PagePaths.FUNDAMENTALS_LIST_PATH,
      PagePaths.ADD_FUNDAMENTALS_PATH,
      PagePaths.EDIT_FUNDAMENTALS_PATH,
    ],
    feature: 'Fundamentals',
  },

  // === Bulk Operations ===
  {
    paths: [PagePaths.BULK_OPERATIONS_PATH],
    feature: 'BulkOperations',
  },
];
